import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import {Box} from '../StyledComponents';
import _ from 'lodash';
import Loading from '../Loading.js';

const ScoreBoxContainer = styled.div`
  display: flex;

  @media only screen and (max-width: 524px) {
    flex-wrap: wrap;
  }
`;

const ScoreBox = styled.div`
  width:25%;
  padding-left: 10px;

  ${props => props.color1 && css`
      border-left: 5px solid #5ab99a !important;
  `}

  ${props => props.color2 && css`
      border-left: 5px solid #fa7823 !important;
  `}

  ${props => props.color3 && css`
      border-left: 5px solid #b21fd1 !important;
  `}

  ${props => props.color4 && css`
      border-left: 5px solid #0e67b9 !important;
  `}

  ${props => props.color5 && css`
      border-left: 5px solid #ec5b60 !important;
  `}

  @media only screen and (max-width: 524px) {
    width: 50%;
    height: 90px;
    margin-bottom: 15px;
  }

`;

const Label = styled.label`
  display: block;
  max-width: 100%;
  margin-bottom: 10px;
  margin-top: 5px;
  font-size: 11px;
`;

const Index = styled.span`
  margin-top: 5px;
  display: block;
  line-height: 28px;
`;

class ScoreView extends Component {
    getDataPoint(type) {
      const data = this.props.data;
      let year = data.endDate.getFullYear();
      let month = data.endDate.getMonth() + 1;
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      let results = [];

      switch(type) {
        case 'newSubscriptions':
          results = data.newSubscriptions || {};
          break;
        case 'result':
          results = data.result || {};
          break;
        default:
          break;  
      }

      return {
        byline: "(" + monthNames[data.endDate.getMonth()] + " "+ year + ")",
        data: (results[year] && results[year][month]) || "N/A",
      }
    }

    render() {
        const { data } = this.props;

        if (_.isEmpty(data)) {
          return <Box><Loading/></Box>;
        };

        let variableData = data.variableData || {};
        const simulationMode = data.simulationMode;
        const simulationParams = data.simulationParams || {};

        let clientViewSettings = (this.props.user.client && this.props.user.client.viewSettings) || {};

        if (_.isEmpty(variableData)) {
          return <Box><Loading/></Box>;
        }

        let currentScore =  "N/A";
        let targetScore = "N/A";
        let variables = variableData.variables;
        variables.forEach(function(p, i) {
          if (p.id === "total") {
            currentScore = p.score;
            targetScore = p.target;
          };
        });


        const simulatedScore = simulationParams.total ? simulationParams.total.generatedScore : currentScore;

        const score = parseFloat(simulationMode ? simulatedScore : currentScore).toFixed(2);
        let potential = variableData.potential || "N/A";
        let monetaryUnit = variableData.monetaryUnit;

        const datapoints = [
          {
            id: "newSubscriptions",
            label: "NEW SUBSCRIPTIONS"
          },
          {
            id: "result",
            label: "RESULT"
          }
        ];

        return (
            <Box contentHeight={this.props.contentHeight}>
              <ScoreBoxContainer>
                <ScoreBox color1 className="col-xs-6 col-sm-2 col-xs-6 box">
                  <Label>RELEVANCE</Label>
                  <Index className="large-font-size">{score}</Index>
                </ScoreBox>
                <ScoreBox color2 className="col-xs-6 col-sm-2 col-xs-6 box">
                  <Label>RELEVANCE TARGET<span className="tiny-font-size"></span></Label>
                  <Index className="large-font-size">{targetScore}</Index>
                </ScoreBox>

                 {datapoints.map((dp, i) => {
                   return (clientViewSettings[dp.id] && (
                      <ScoreBox color3 className="col-xs-6 col-sm-2 col-xs-6 box" key={dp.id}>
                        <Label>{dp.label}</Label>
                        <Index className="large-font-size">{this.getDataPoint(dp.id) && this.getDataPoint(dp.id).data}</Index>
                        <span className="tiny-msek small-font-size">{this.getDataPoint(dp.id) && this.getDataPoint(dp.id).byline}</span>
                      </ScoreBox>
                    ))||null
                 })}

                <ScoreBox color4 className="col-xs-6 col-sm-2 col-xs-6 box">
                    <Label>POTENTIAL <span className="tiny-font-size">(2018)</span></Label>
                    <Index className="large-font-size">{potential}</Index>
                    <span className="tiny-msek small-font-size">{potential && monetaryUnit ? "("+monetaryUnit+")":null}</span>
                </ScoreBox>
              </ScoreBoxContainer>
            </Box>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        data: state.data,
        user: state.user
    };
}

export default connect(mapStateToProps)(ScoreView);



// WEBPACK FOOTER //
// ./src/components/dataViews/ScoreView.js